// extracted by mini-css-extract-plugin
export default {"shop":"KillsUpgradePage_shop__BWXZs","shopButton":"KillsUpgradePage_shopButton__n-8A1"};